export default class APIConfig {
  static isDebug = process.env.NODE_ENV !== 'production';
  static Host = APIConfig.isDebug ? 'http://localhost:9516' : 'https://codus.me'
  static BPIURL = APIConfig.Host + '/bpi'
  static APIURL = APIConfig.Host + '/api'
}
